export interface OhayoImageConfig {
  /**
   * 默认大小，默认值：`64`，单位：px
   */
  size?: number;

  /**
   * 错误图片，默认：`./assets/img/logo.svg`
   */
  error?: string;
}
